import React from 'react';
import { Route, Switch } from 'react-router-dom';

import Can from '~/contexts/Can';
import NotPermissionPage from '~/pages/NotPermissionPage';
import {
  reportUsersActives,
  reportPackagesActives,
  reportPackagesEspecialtyActives,
  sales,
  SIDMedicalAppointmentsReports as SIDMedicalAppointmentsReportsRoute,
  accidentReports,
  appointmentRating,
  logsReports,
  activeClients,
  reportIdsIntegration,
  reportMevoPrescricoes,
  reportStation,
} from '~/config/routes';

import UserActives from './UserActives';
import PackageActives from './PackageActives';
import PackageEspecialtyActives from './PackageEspecialtyActives';
import Sales from './Sales';
import SIDMedicalAppointmentsReports from './SIDMedicalAppointmentsReports';
import AccidentReports from './AccidentReports';
import AppointmentRating from './AppointmentRating';
import LogsReports from './LogsReports';
import ActiveClients from './ActiveClients';
import IdsIntegration from './IdsIntegration';
import MevoPrescricoes from './MevoPrescricoes';
import StationReport from './StationReport';

function Reports() {
  return (
    <Switch>
      <Route
        exact
        path={reportUsersActives.spec}
        render={(props) => (
          <>
            <Can I="show" a="Reports">
              {() => <UserActives {...props} />}
            </Can>
            <Can not I="show" a="Reports">
              {() => <NotPermissionPage />}
            </Can>
          </>
        )}
      />
      <Route
        exact
        path={reportPackagesActives.spec}
        render={(props) => (
          <>
            <Can I="show" a="Reports">
              {() => <PackageActives {...props} />}
            </Can>
            <Can not I="show" a="Reports">
              {() => <NotPermissionPage />}
            </Can>
          </>
        )}
      />
      <Route
        exact
        path={reportPackagesEspecialtyActives.spec}
        render={(props) => (
          <>
            <Can I="show" a="Reports">
              {() => <PackageEspecialtyActives {...props} />}
            </Can>
            <Can not I="show" a="Reports">
              {() => <NotPermissionPage />}
            </Can>
          </>
        )}
      />
      <Route
        exact
        path={sales.spec}
        render={(props) => (
          <>
            <Can I="show" a="Reports">
              {() => <Sales {...props} />}
            </Can>
            <Can not I="show" a="Reports">
              {() => <NotPermissionPage />}
            </Can>
          </>
        )}
      />
      <Route
        exact
        path={accidentReports.spec}
        render={(props) => (
          <>
            <Can I="show" a="AccidentReports">
              {() => <AccidentReports {...props} />}
            </Can>
            <Can not I="show" a="AccidentReports">
              {() => <NotPermissionPage />}
            </Can>
          </>
        )}
      />
      <Route
        exact
        path={logsReports.spec}
        render={(props) => (
          <>
            <Can I="show" a="Reports">
              {() => <LogsReports {...props} />}
            </Can>
            <Can not I="show" a="Reports">
              {() => <NotPermissionPage />}
            </Can>
          </>
        )}
      />
      <Route
        exact
        path={appointmentRating.spec}
        render={(props) => (
          <>
            <Can I="show" a="Reports">
              {() => <AppointmentRating {...props} />}
            </Can>
            <Can not I="show" a="Reports">
              {() => <NotPermissionPage />}
            </Can>
          </>
        )}
      />

      <Route
        exact
        path={activeClients.spec}
        render={(props) => (
          <>
            <Can I="show" a="Reports">
              {() => <ActiveClients {...props} />}
            </Can>
            <Can not I="show" a="Reports">
              {() => <NotPermissionPage />}
            </Can>
          </>
        )}
      />

      <Route
        exact
        path={SIDMedicalAppointmentsReportsRoute.spec}
        render={(props) => (
          <>
            <Can I="show" a="Reports">
              {() => <SIDMedicalAppointmentsReports {...props} />}
            </Can>
            <Can not I="show" a="Reports">
              {() => <NotPermissionPage />}
            </Can>
          </>
        )}
      />
      <Route
        exact
        path={reportIdsIntegration.spec}
        render={(props) => (
          <>
            <Can I="show" a="Reports">
              {() => <IdsIntegration {...props} />}
            </Can>
            <Can not I="show" a="Reports">
              {() => <NotPermissionPage />}
            </Can>
          </>
        )}
      />
      <Route
        exact
        path={reportMevoPrescricoes.spec}
        render={(props) => (
          <>
            <Can I="show" a="Reports">
              {() => <MevoPrescricoes {...props} />}
            </Can>
            <Can not I="show" a="Reports">
              {() => <NotPermissionPage />}
            </Can>
          </>
        )}
      />
      <Route
        exact
        path={reportStation.spec}
        render={(props) => (
          <>
            <Can I="show" a="Reports">
              {() => <StationReport {...props} />}
            </Can>
            <Can not I="show" a="Reports">
              {() => <NotPermissionPage />}
            </Can>
          </>
        )}
      />
    </Switch>
  );
}
export default Reports;
